module.exports = __webpack_public_path__ + "static/media/XVIe.23276bed.png";